import client from '@/shared/apis/client'

/**
 * 改善依頼 (店舗 → 当社) の送信。
 *
 * 指導 1 回 (= 薬歴 ID) に紐づく一言。back は送信時点の SOAP の版と送った人を添えて保存する
 * (yakureki-back log/231)。画面に状態は残さない (= 返り値の id は front では使わない)。
 * note が空 / 500 字超のときは back が 400、他薬局の薬歴は 404 を返す。
 */
export const postFeedback = async (
  yakurekiId: string,
  note: string
): Promise<{ id: string }> => {
  const response = await client.post<{ id: string }>(
    `/api/yakureki/${yakurekiId}/feedback/`,
    { note }
  )
  return response.data
}
